
/**
 * Универсальная функция для скачивания файлов на стороне клиента.
 * @param {string} filename - Имя сохраняемого файла
 * @param {Blob|any} dataOrBlob - Готовый Blob или сырые данные (строка, массив)
 * @param {string} [type] - MIME-тип (нужен только если передаются сырые данные)
 */
export default function saveFile(filename = 'file_from_transcript', dataOrBlob, type) {
  if (dataOrBlob === null || dataOrBlob === undefined) return;

  /* превращаем входные данные в Blob, если это не Blob */
  const blob = dataOrBlob instanceof Blob
    ? dataOrBlob
    : new Blob([dataOrBlob], { type });

  /* для IE/Old Edge */
  if (typeof navigator !== 'undefined' && navigator.msSaveBlob) {
    return navigator.msSaveBlob(blob, filename);
  }

  const tagA = document.createElement('a');
  const url = window.URL.createObjectURL(blob);

  tagA.style.display = 'none';
  tagA.href = url;
  tagA.download = filename;

  document.body.appendChild(tagA);
  tagA.click();

  /* Очистка DOM и памяти */
  document.body.removeChild(tagA);
  window.URL.revokeObjectURL(url);
}
